<!-- 客服侧边栏-H5 -->
<template>
    <div class="allSilderH5" v-if="noShowRouteName.indexOf($route.name) === -1">
        <div class="item service" @click="handleOpenServicePopup">
            <img class="icon" :src="require('@/common/images/common/service_h5_icon.png')" alt="">
            <div class="label">在线客服</div>
        </div>
        <div class="line"></div>
        <div class="item" @click="handleGoTop">
            <img class="icon" :src="require('@/common/images/common/go_top_h5_icon.png')" alt="">
            <div class="label">返回顶部</div>
        </div>
        <van-popup v-model="showServicePopup" class="servicePopup" :close-on-click-overlay="false">
            <div class="servicePopupContent">
                <img class="code" :src="require('@/common/images/common/service_code.png')" alt="">
                <div class="tipsText">免费在线咨询</div>
                <div class="tipsText">快速帮您解决问题</div>
                <img class="closeImg" @click="handleCloseServicePopup" :src="require('@/common/images/activeTools/close.png')" alt="" />
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showServicePopup: false,
            noShowRouteName: ['MliveDetails', 'MCourseView']
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpenServicePopup() {
            this.showServicePopup = true
        },
        handleCloseServicePopup() {
            this.showServicePopup = false
        },
        handleGoTop() {
            document.documentElement.scrollTop = 0
        }
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.allSilderH5 {
    padding: 0 0.08rem;
    width: auto;
    position: fixed;
    bottom: 1rem;
    right: 0.2rem;
    background: #fff;
    box-shadow: 0px 0px 0.06rem 0px rgba(0,0,0,0.25);
    border-radius: 0.06rem;
    z-index: 10000;
    .item {
        padding: 0.2rem 0;
        .icon {
            width: 0.4rem;
            height: 0.4rem;
            margin: 0 auto 0.1rem;
        }
        .label {
            font-size: 0.18rem;
            text-align: center;
            line-height: 0.2rem;
            white-space: nowrap;
        }
        &.service {
            .label {
                color: #397FFF;
            }
        }
    }
    .line {
        width: 0.6rem;
        height: 0.01rem;
        background: #EEEEEE;
        margin: auto;
    }
}
.servicePopup {
    border-radius: 0.2rem;
    background: transparent;
    overflow: visible;
    .servicePopupContent {
        width: 4.1rem;
        height: 5.08rem;
        border-radius: 0.2rem;
        background: #fff;
        padding: 0.3rem 0 0;
        position: relative;
        box-sizing: border-box;
        .code {
            width: 3.5rem;
            height: 3.5rem;
            margin: 0 auto 0.3rem;
        }
        .tipsText {
            font-size: 0.28rem;
            color: #333333;
            line-height: 0.4rem;
            text-align: center;
        }
        .closeImg {
            width: 0.6rem;
            height: 0.6rem;
            position: absolute;
            bottom: -0.9rem;
            left: 50%;
            transform: translateX(-0.3rem);
        }
    }
}
</style>